import { Modal } from 'react-bootstrap'
import React from 'react'
import PropTypes from 'prop-types'
import NewPlaylistForm from './NewPlaylistForm'
import AloModal from '../../AloModal'

// Set onCancel to onHide() so that we don't trigger onPlaylistAdd(uuid) within <PlaylistSelector/>, as it was causing render issues in /my/playlist.
// This is just a quick stop-gap until we rework /my/playlists to not be hella janx
// For onCancel and closing the modal, we set onHide to () => props.onHide() so that the event object is not passed to the onHide callback, which is expecting a uuid param in PlaylistSelector

const CreateNewPlaylistModal = props => {
  return (
    <AloModal
      className='playlist-modal modal-confirm'
      backdrop="static"
      show={props.active}
      onHide={() => props.onHide()}
    >
      <Modal.Header>Create New Playlist</Modal.Header>
      <NewPlaylistForm
        onCancel={() => props.onHide()}
        onAdded={props.onHide}
        planEntryId={props.planEntryId}
      />
    </AloModal>
  )
}

CreateNewPlaylistModal.propTypes = {
  active: PropTypes.bool,
  onHide: PropTypes.func,
  planEntryId: PropTypes.number
}

export default CreateNewPlaylistModal
